import { translateLanguage } from "@/helper/i18n";
import { useAppContext } from "@/use-context/Context";
import { useRef, useEffect, useState } from "react";

interface ListCategoryProps {
    initialCategories: any[];
    setCategoryId: (id: string) => void;
    categoryId: string;
    setIsClick: (value: boolean) => void;
    handleCategory: () => void;
    handleDiscount: (id: string) => void;
}

export default function ListCategory({ initialCategories, setCategoryId, setIsClick, handleCategory, handleDiscount }: ListCategoryProps) {
    const { setLoading } = useAppContext();

    const categoryRefs = useRef<(HTMLDivElement | null)[]>([]);

    const [activeCategory, setActiveCategory] = useState<string>("");

    const handleCategoryClick = (id: string, isDiscount?: boolean) => {
        setIsClick(true);
        setLoading(true);
        setCategoryId(id);
        setActiveCategory(id);
        localStorage.setItem("categoryId", id);

        const params = new URLSearchParams(window.location.search);
        params.set("categoryId", id);
        window.history.pushState({}, "", `?${params.toString()}`);

        if (isDiscount) handleDiscount(id);
        else handleCategory();
    };

    useEffect(() => {
        const stored = localStorage.getItem("categoryId");
        if (!stored && initialCategories.length > 0) {
            setCategoryId(initialCategories[0]._id);
            setActiveCategory(initialCategories[0]._id);
            localStorage.setItem("categoryId", initialCategories[0]._id);
        } else if (stored) {
            setCategoryId(stored);
            setActiveCategory(stored);
        }
    }, [initialCategories]);

    useEffect(() => {
        if (!activeCategory || initialCategories.length === 0) return;

        const index = initialCategories.findIndex(cat => cat._id === activeCategory);
        const ref = categoryRefs.current[index];

        if (ref) {
            ref.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
            });
        }
    }, [activeCategory, initialCategories]);

    return (
        <div className="pb-4 md:pb-5 flex gap-x-2 overflow-x-scroll whitespace-nowrap scroll-hidden">
            {initialCategories.map((item, idx) => {
                const isActive = activeCategory === item._id;

                return (
                    <div
                        key={item._id ?? idx}
                        ref={el => (categoryRefs.current[idx] = el)}
                        className={`cursor-pointer ${isActive ? "pointer-events-none" : ""}`}
                        onClick={() => {
                            if (isActive) return;
                            handleCategoryClick(item._id, item.discount != null);
                        }}
                    >
                        <div
                            className={`flex outline-none ring-0 focus:ring-0 focus:outline-none flex-shrink-0 px-4 py-2 rounded-lg
                                ${isActive
                                    ? "text-primary bg-white border border-primary font-medium"
                                    : "bg-primary text-white"
                                }`}
                        >
                            {translateLanguage(item.name, item.nameKH ?? item.name)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
